import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { getLeadSources, getUsersWithLeadRole } from '../api';

const LeadAccountSearchForm = ({ onSearch, initialFilters = {} }) => {
    const [localFilters, setLocalFilters] = useState({
        name: '',
        email: '',
        zipCode: '',
        leadSourceId: '',
        assignedLeadId: '',
        ...initialFilters
    });

    const [leadSources, setLeadSources] = useState([]);
    const [leads, setLeads] = useState([]);
    const [isInitialized, setIsInitialized] = useState(false);
    const searchTimeoutRef = useRef(null);
    const lastFiltersRef = useRef(JSON.stringify({ name: '', email: '', zipCode: '', leadSourceId: '', assignedLeadId: '', ...initialFilters }));

    useEffect(() => {
        const loadData = async () => {
            try {
                const [leadSourcesData, leadsData] = await Promise.all([
                    getLeadSources(),
                    getUsersWithLeadRole(9) // 9 es el roleId para leads
                ]);
                setLeadSources(leadSourcesData || []);
                setLeads(leadsData || []);
                setIsInitialized(true);
            } catch (error) {
                console.error('Error loading filter data:', error);
            }
        };
        loadData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setLocalFilters(prev => ({ ...prev, [name]: value }));
    };

    const triggerSearch = useCallback((filters) => {
        // Filtrar valores vacíos antes de enviar
        const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                acc[key] = value;
            }
            return acc;
        }, {});
        onSearch(cleanFilters);
    }, [onSearch]);

    useEffect(() => {
        if (!isInitialized) return;
        
        const currentFilters = JSON.stringify(localFilters);
        if (currentFilters === lastFiltersRef.current) return;
        
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }
        
        searchTimeoutRef.current = setTimeout(() => {
            triggerSearch(localFilters);
            lastFiltersRef.current = currentFilters;
        }, 500);
        
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, [localFilters, isInitialized, triggerSearch]);

    return (
        <Form>
            <Row>
                <Col md={3}>
                    <Form.Group className="mb-3">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={localFilters.name}
                            onChange={handleChange}
                            placeholder="Buscar por nombre"
                            data-testid="search-name-input"
                        />
                    </Form.Group>
                </Col>
                <Col md={3}>
                    <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="text"
                            name="email"
                            value={localFilters.email}
                            onChange={handleChange}
                            placeholder="Buscar por email"
                            data-testid="search-email-input"
                        />
                    </Form.Group>
                </Col>
                <Col md={3}>
                    <Form.Group className="mb-3">
                        <Form.Label>Código Postal</Form.Label>
                        <Form.Control
                            type="text"
                            name="zipCode"
                            value={localFilters.zipCode}
                            onChange={handleChange}
                            placeholder="Buscar por código postal"
                            data-testid="search-zipcode-input"
                        />
                    </Form.Group>
                </Col>
                <Col md={3}>
                    <Form.Group className="mb-3">
                        <Form.Label>Fuente de Lead</Form.Label>
                        <Form.Select
                            name="leadSourceId"
                            value={localFilters.leadSourceId}
                            onChange={handleChange}
                            data-testid="search-source-select"
                        >
                            <option value="">Todas</option>
                            {leadSources.map(source => (
                                <option key={source.valueId} value={source.valueId}>
                                    {source.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
            
            <Row>
                <Col md={4}>
                    <Form.Group className="mb-3">
                        <Form.Label>Lead Asignado</Form.Label>
                        <Form.Select
                            name="assignedLeadId"
                            value={localFilters.assignedLeadId}
                            onChange={handleChange}
                            data-testid="search-assigned-lead-select"
                        >
                            <option value="">Todos</option>
                            {leads.map(user => (
                                <option key={user.id} value={user.id}>
                                    {user.username}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row>
        </Form>
    );
};

export default LeadAccountSearchForm;